export function MercedesBenzIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 1000 1000.52"
      aria-hidden="true"
      {...props}
    >
      <path
        clipRule="evenodd"
        fill="#73797c"
        fillRule="evenodd"
        d="M732.05 56.712C891.26 140.479 1000 307.492 1000 500S891.26 860.042 732.05 943.288v-57.232c60.874-36.42 112.383-87.409 149.844-147.763L732.05 677.42v-92.612L896.462 713.32c34.34-63.475 53.59-135.796 53.59-213.319 0-163.371-87.409-306.972-218.002-386.056V56.712zM500.52 0c83.247 0 161.81 20.291 231.53 56.712v57.232c-63.996-38.502-138.918-61.395-218.002-63.996l57.232 409.47 160.77 125.39v92.611l-232.57-94.172-231.01 94.693v-92.092l161.811-126.43 56.712-409.47c-80.125 2.601-154.527 25.494-218.523 63.996V56.712C337.67 20.292 416.753 0 500.52 0zm231.53 943.288c-69.72 36.42-148.283 57.232-231.53 57.232-83.767 0-162.85-20.811-232.05-56.711v-57.753c67.638 41.103 147.243 64.516 232.05 64.516 84.287 0 163.372-23.413 231.53-64.516v57.232zm-463.58.52C108.74 860.043 0 692.509 0 500 0 307.492 108.74 140.479 268.47 56.712v57.232C137.357 193.028 49.948 336.108 49.948 500c0 77.523 19.771 150.884 54.11 214.36L268.47 585.848v92.092l-149.323 61.394c37.46 59.834 88.45 110.302 149.323 146.722v57.753z"
      />
    </svg>
  )
}
